import { useRecoilValue } from 'recoil'
import unitInstancesAtom from '@/pages/MDM/atoms/units.instances.atom.ts'

const useUnitInstances = () => {
  const state = useRecoilValue(unitInstancesAtom)

  return state.items
}

export default useUnitInstances
